import React from 'react'
import { createRoot } from 'react-dom/client'
import { App } from './components/App'

export const startInvoiceAccounts = invoiceAccts => {
  const root = createRoot(document.getElementById('invoiceAccountsApp'))
  root.render(<App invoiceAccts={invoiceAccts} />)
}
